module.exports = __webpack_public_path__ + "img/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.3343b484.webp";